import { render } from "./newsPage.vue?vue&type=template&id=f316de4a&scoped=true"
import script from "./newsPage.vue?vue&type=script&lang=js"
export * from "./newsPage.vue?vue&type=script&lang=js"

import "./newsPage.vue?vue&type=style&index=0&id=f316de4a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f316de4a"]])

export default __exports__